export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  borderWidth: '1',
  padding: '2',
  fontSize: '3',
  showOriginDestinationImage: false,
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: false,
  fareItemJourneyType: {},
  showTravelClass: false,
  fareItemTravelClass: {},
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: false,
    showOrigin: false,
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    style: {
      lineHeight: '1',
    },
  },
  showRoute: true,
  fareItemRoute: {
    showOrigin: false,
    fontWeight: 'bold',
    fontSize: '4',
    textColor: 'black',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: false,
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: false,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareBodyItem: {
    grow: '1',
    textColor: 'dark',
  },
  fareFooterItem: {
    flexDirection: 'row',
    justifyContent: 'end',
    alignItems: 'center',
    textColor: 'dark',
    grow: '1',
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'right',
    paddingWidth: '2',
    pricePromoStyles: {
      fontWeight: 'bold',
      fontSize: '3',
    },
    currencyStyles: {
      fontSize: '5',
      textColor: 'black',
    },
  },
  showLastSeen: false,
  fareItemLastSeen: {
    border: true,
    shadow: '@theme:card.shadow',
    rounded: '@theme:badge.rounded',
    fontName: '@theme:card.fontName',
    padding: '1',
    labelStyles: {
      fontWeight: 'bold',
    },
  },
  showCallToAction: true,
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    showCallToActionTextMin: true,
    style: {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
  },
};
